import { Component, OnInit, OnDestroy } from '@angular/core';
import { OidcAuthService } from '../../services/oidc-auth.service';
import { Router } from '@angular/router';
import { tap, takeWhile } from 'rxjs';
import { ActionDispatcher } from '@store/dispatcher.service';
import * as userSettingActions from '@user-settings/actions/user-settings';


/**
 * This component is used to provide a callback route for identityserver to call following a successful login.
 * It completeAuthentication using the oidc-auth service and then redirects to wherever the user was trying to get to.
 */
@Component({
  selector: 'mojo-signin-callback',
  templateUrl: './signin-callback.component.html'
})
export class SigninCallbackComponent implements OnInit {
  private isAlive = true;

  ngOnInit() {

    this.authService.completeAuthentication().pipe(takeWhile(() => this.isAlive)).subscribe((authenticated: boolean) => {
      if (authenticated) {
        this.actionDispatcher.dispatch(new userSettingActions.LoadFromSignIn());
        const url = this.authService.currentUser.state.url;
        this.router.navigateByUrl(url);
      }
    });
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  constructor(
    private readonly actionDispatcher: ActionDispatcher,
    private readonly authService: OidcAuthService,
    private readonly router: Router
  ) { }
}
